import React, { useEffect, useState } from 'react';
import AuthLayout from '../../layout/authLayout';
import { Typography, Grid, Button, Link } from '@mui/material';
import InputBox from '../../components/inputBox';
import ApiClient from '../../config/api';
import EastIcon from '@mui/icons-material/East';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { convertPersianToEnglish } from '../../components/converter';
import getDeviceInformation from '../../components/getDeviceInformation';
import getFcmToken from '../../components/getFcmToken';
import getVersion from '../../components/getVersion';
import sendLog from '../../components/sendLog';
import CircularProgress from '@mui/material/CircularProgress';
import { setRoute } from '../../store/globalSlice';

const Password = () => {
  const api = ApiClient();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [value, setValue] = useState('');
  const navigate = useNavigate();
  const phoneNumber = useSelector((st) => st?.auth?.phoneNumber);
  const dispatch = useDispatch();
  const [fcmToken, setFcmToken] = useState('');
  const [version, setVersion] = useState('');
  const [deviceInformation, setDeviceInformation] = useState('');

  const sendFcmToken = async () => {
    try {
      const response = await api.post('/api/app/v1/user/devices', {
        application_id: 'shipito',
        application_version: String(version || ""),
        device_id: String(deviceInformation?.osInternalBuildId || ""),
        device_type: String(deviceInformation?.deviceType || ""),
        push_token: String(fcmToken || ""),
        device_os: String(deviceInformation?.osVersion || ""),
        device_os_version: String(deviceInformation?.osVersion || ""),
        device_brand: String(deviceInformation?.productName || ""),
        device_model_id: String(deviceInformation?.modelId || ""),
      });
    } catch (error) {
      console.error(error)
      sendLog(error)
    }
  };

  const onRecievedMessage = (event) => {
    if (event?.data?.type == 'token') {
      setFcmToken(event?.data?.data)
    } else if (event?.data?.type == 'device') {
      setDeviceInformation(event?.data?.data)
    } else if (event?.data?.type == 'version') {
      setVersion(event?.data?.data)
    }
    sendLog(event?.data?.data)
  };

  useEffect(function () {
    window.addEventListener('message', onRecievedMessage);

    return function () {
      window.removeEventListener('message', onRecievedMessage);
    };
  });

  useEffect(() => {
    if (!phoneNumber) {
      dispatch(setRoute('/'));
      navigate('/');
    }
    getFcmToken();
    getVersion();
    getDeviceInformation();
  }, []);

  const handleInputChange = (newValue) => {
    setValue(newValue);
  };

  const onSubmit = async () => {
    if (value.length != 0) {
      try {
        setIsLoading(true);
        setError('');
        const convertedPhone = convertPersianToEnglish(phoneNumber);
        const response = await api.post('/api/app/v1/auth/login', {
          username: convertedPhone,
          password: value,
          channel: 'shipito',
          app_name: 'shipito',
        });
        localStorage.setItem('info', JSON.stringify(response.data));
        await sendFcmToken()
        dispatch(setRoute('/missions'));
        navigate('/missions', { replace: true });
        window.location.reload();
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        if (error.response && error.response.data) {
          const responseData = error.response.data;
          if (responseData.message) {
            setError(responseData.message);
          } else {
            setError('مشکلی پیش آمده است');
          }
        } else {
          setError('مشکلی پیش آمده است');
        }
      }
    } else {
      setError('رمز عبور را وارد کنید');
    }
  };

  return (
    <AuthLayout>
      <EastIcon
        sx={{ marginTop: '20px', paddingRight: '20px', paddingLeft: '20px' }}
        onClick={() => {
          navigate(-1);
        }}
        className={'clickable'}
      />
      <Typography
        paddingRight={'20px'}
        paddingLeft={'20px'}
        fontSize={24}
        fontWeight={600}
        marginTop={'24px'}
      >
        رمز عبور را وارد نمایید
      </Typography>
      <Typography
        paddingRight={'20px'}
        paddingLeft={'20px'}
        color={'primary.gray'}
        fontSize={16}
        fontWeight={600}
        marginTop={'12px'}
        marginBottom={'24px'}
      >
        رمز عبور شماره {phoneNumber} را وارد کنید
      </Typography>
      <Typography
        paddingRight={'20px'}
        paddingLeft={'20px'}
        color={'primary.gray'}
        fontSize={16}
        fontWeight={600}
        marginTop={'12px'}
        marginBottom={'24px'}
      >
        شماره موبایل اشتباه است؟
        <Link sx={{ textDecoration: 'none', marginLeft: '5px' }} href="/">
          ویرایش
        </Link>
      </Typography>
      <Grid
        paddingRight={'20px'}
        paddingLeft={'20px'}
        container
        flexDirection={'column'}
      >
        <Grid item>
          <InputBox
            label="رمز عبور"
            value={value}
            setValue={handleInputChange}
            onSubmit={onSubmit}
            isLoading={isLoading}
            type="password"
            icon={null}
            error={error}
          />
        </Grid>
        <Grid item>
          <Button
            onClick={onSubmit}
            disabled={isLoading}
            sx={{
              marginTop: '24px',
              width: '100%',
              height: '57px',
              borderRadius: '8px',
              color: 'primary.contrastText',
              fontFamily: 'iran-sans-light',
              fontSize: '16px',
              fontWeight: '600',
              marginTop: '0px',
            }}
            size="large"
            variant="contained"
          >
            {isLoading ? <CircularProgress size={24} sx={{ color: 'primary.contrastText' }} /> : 'تایید و ادامه'}
          </Button>
          <Button
            onClick={() => {
              navigate('/otp?type=otp_login');
            }}
            disabled={isLoading}
            sx={{
              marginTop: '24px',
              width: '100%',
              height: '57px',
              borderRadius: '8px',
              fontFamily: 'iran-sans-light',
              fontSize: '16px',
              fontWeight: '600',
              marginTop: '16px',
            }}
            size="large"
            variant="outlined"
          >
            {isLoading ? <CircularProgress /> : 'ورود با رمز یکبار مصرف'}
          </Button>
        </Grid>
      </Grid>
    </AuthLayout>
  );
};

export default Password;
